import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule, BOOTSTRAP_CONFIG } from './app/app.module';
import { environment } from './environments/environment';

fetch('assets/config/bootstrap-config.json')
  .then((res) => res.json())
  .then((config) => {
    if (environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic([{ provide: BOOTSTRAP_CONFIG, useValue: config }]).bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });

